module.exports = __webpack_public_path__ + "img/tree-view-icon.dcc71292.png";